import React, {createContext, useContext, useEffect, useState} from 'react'
import {SpectatorData} from '@colonist/game-state-types'

interface UIGameSpectatorsContextProps {
    spectators: SpectatorData[]
}

export const UIGameSpectatorsContext = createContext<UIGameSpectatorsContextProps>({
    spectators: [],
})

let globalSetSpectators: (spectators: SpectatorData[]) => void = () => ({})
export const setGlobalSpectators = (spectators: SpectatorData[]) => {
    globalSetSpectators(spectators)
}

export const useUIGameSpectatorsContext = () => useContext(UIGameSpectatorsContext)

export const UIGameSpectatorsProvider = ({
    initialSpectators,
    children,
}: {
    initialSpectators?: SpectatorData[]
    children: React.ReactNode
}) => {
    const [spectators, setSpectators] = useState<SpectatorData[]>(initialSpectators || [])

    useEffect(() => {
        globalSetSpectators = setSpectators
    }, [])

    return (
        <UIGameSpectatorsContext.Provider value={{spectators: spectators}}>
            {children}
        </UIGameSpectatorsContext.Provider>
    )
}
